module.exports = __webpack_public_path__ + "img/Light SleepStart.52da61c4.png";